import { render, staticRenderFns } from "./construction.vue?vue&type=template&id=ca21521e&scoped=true&"
import script from "./construction.vue?vue&type=script&lang=js&"
export * from "./construction.vue?vue&type=script&lang=js&"
import style0 from "./construction.vue?vue&type=style&index=0&id=ca21521e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca21521e",
  null
  
)

export default component.exports